import { ContainerLayout } from 'layouts';
import { Header, ProgressCircle } from '@ds/ui';
import React, { ReactElement, useEffect, useRef, useState } from 'react';
import Center = Header.Center;
import { apiService } from 'services';
import { SupportedErrorType } from '../DocumentLockedPage';
import { ContinueModel } from 'types/ContinueModel';

const ErrorCallbackComponent = (): ReactElement => {
    const [errorContinueModel, setErrorContinueModel] = useState<ContinueModel | undefined>(undefined);
    const formRef = useRef<HTMLFormElement>(null);

    const errorType: SupportedErrorType = 'AttemptsExceeded';

    useEffect(() => {
        apiService.Get<ContinueModel>('App/continue/error').then(response => {
            setErrorContinueModel(response);
        });
    }, []);

    useEffect(() => {
        if (formRef.current && errorContinueModel) {
            formRef.current.submit();
        }
    }, [formRef, errorContinueModel]);

    return (
        <ContainerLayout>
            <ContainerLayout.InnerContent>
                <Center>
                    <ProgressCircle hideText text="Loading"></ProgressCircle>
                </Center>
                {errorContinueModel && (
                    <form method="POST" action={errorContinueModel.callbackUri} ref={formRef} data-qa="verify-document-locked-form">
                        <input type="hidden" name="session_id" value={errorContinueModel.sessionId} data-qa="verify-document-locked-form-sessionid" />
                        <input type="hidden" name="error" value={errorType} data-qa="verify-document-locked-form-error" />
                    </form>
                )}
            </ContainerLayout.InnerContent>
        </ContainerLayout>
    );
};

export default ErrorCallbackComponent;
